import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ContractType } from './contract-type.model';
import { Contract } from './contract.model';
import { AttributeValues } from './attribute-values.model';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { ContractAttributes } from './contract-attributes.model';
import { ContractTemplate } from './contract-template.model';
import { Approver } from 'src/app/shared/approver.model';
import { Users } from 'src/app/shared/users.model';
import { UserService } from 'src/app/shared/user.service';
import { SupportingDocument } from './supporting-document.model';
import { Entitlement } from './entitlement.model';
import { Reviewer } from 'src/app/shared/reviewer.model';
import { Clauses } from './clauses.model';
import { Templates } from './templates.model';
import * as moment from 'moment';




@Injectable({
  providedIn: 'root'
})
export class ContractService {
  addContractTeam(data: any, contractId: any) {
    throw new Error('Method not implemented.');
  }


  //private currentStage = new BehaviorSubject(0);
  //currentStageObserver = this.currentStage.asObservable();

  completedStep: number;

  // private currentValidationStage = new BehaviorSubject(1);
  // currentValidationStageObserver = this.currentValidationStage.asObservable();

  public AlertMessage = new BehaviorSubject("");
  AlertMessageObserver = this.AlertMessage.asObservable();
  /*private contract = new BehaviorSubject(null);
  contractObserver = this.contract.asObservable();
  private contractTypeList = new BehaviorSubject(null);
  contractTypeListObserver = this.contractTypeList.asObservable();*/
  contractBaseUrl: String;
  contracttypeBaseUrl: String;

  ContractTypeList: ContractType[];
  ContractType: ContractType;

  Contract: Contract;
  ContractList: Contract[];

  ClausesList: Clauses[];
  Clause: Clauses;

  //////////templates list array////swapnil////
  TemplateList: Templates[];
  templates: Templates;
  ////////////////////////////////////////////

  TransactionTypes: [] = []; //Modal class is not created since there is no updation for this Object
  AttributeValues: AttributeValues[] = [];

  ContractDetailAttributes: ContractAttributes[] = [];
  ContractSummaryAttributes: ContractAttributes[] = [];

  AllSupportingDocuments: SupportingDocument

  ContractDetailsPlusSummaryAttributes: ContractAttributes[] = [];

  ContractTemplateList: ContractTemplate[] = [];

  ContractGenerated: boolean = false;

  thisContractCreatedBy: Users = null;

  atleastOneApproverLeft: boolean = false;
  Approver: Approver;
  Reviewer: Reviewer;
  allContractApprovers: Approver[] = [];
  allContractReviewers: Reviewer[] = [];
  remainingUsers = [];
  remainingUsers1 = [];
  userFullName: string;
  loggedInIsCreater: boolean = true;
  DocuSignObject = {
    contractID: null,
    name: null,
    email: null,
    secret: 1
  }


  entitlement: Entitlement;
  entitlementTypes: [] = [];
  entitlementTimeLines: [] = [];
  entitlementReminderNotices: [] = [];
  entitlementFrequencies: [] = [];
  entitlementApprovals: [] = [];
  entitlements = [];
  entitlementlist = [];

  auditLog = [];
  versions = [];
  contractTypeId2: String;
  ContractTemplateList2: ContractTemplate[];


  constructor(
    private http: HttpClient,
    private router: Router,
    public userService: UserService,
    private route: ActivatedRoute,
  ) {
    this.Approver = new Approver();
    this.Contract = new Contract();
    this.completedStep = this.Contract.completedStep;
    this.contractBaseUrl = environment.contractApiURL;
    this.contracttypeBaseUrl = environment.contractTypeApiURL;
    if (this.userService.loggedinUser?.middleName)
      this.userFullName = this.userService.loggedinUser.firstName + " " + this.userService.loggedinUser.middleName + " " + this.userService.loggedinUser.lastName;
    else
      this.userFullName = this.userService.loggedinUser.firstName + " " + this.userService.loggedinUser.lastName;
  }

  refreshContract(id, retryCount = 0) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/tenants/" + this.userService.loggedinUser.tenantId + "/contracts/" + id).toPromise().then((res: Contract) => {
        resolve(res);
      }).catch((error) => {
        // Handle HTTP parsing errors specifically
        if (error.name === 'HttpErrorResponse' && error.status === 200 && !error.ok) {
          console.error('JSON parsing error due to circular references in backend response:', error);

          // Retry up to 2 times for parsing errors
          if (retryCount < 2) {
            console.log(`Retrying contract fetch (attempt ${retryCount + 1})...`);
            setTimeout(() => {
              this.refreshContract(id, retryCount + 1).then(resolve).catch(reject);
            }, 1000 * (retryCount + 1)); // Exponential backoff
            return;
          }

          // Create a minimal contract object to prevent complete failure
          const fallbackContract: Contract = {
            id: id,
            completedStep: 1,
            contractTypeId: null,
            contractTypeName: 'Unknown',
            transactionTypeId: null,
            transactionTypeName: 'Unknown',
            name: 'Contract (Data Error)',
            reason: null,
            version: 1.0,
            templateId: null,
            documentId: null,
            statusId: 1,
            rejectedBy: null,
            statusName: 'Initiated',
            aiEnabled: 0,
            isMandatoryFilled: false,
            isGenerated: false,
            isDeleted: false,
            updateCount: 0,
            createdByUserId: null,
            createdByName: 'Unknown',
            createdBy: 'Unknown',
            createDate: new Date(),
            updatedBy: 'System',
            updateDate: new Date(),
            attributes: []
          };
          resolve(fallbackContract);
        } else {
          reject(error);
        }
      });
    });

  }
  getContract(contractID: number) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/tenants/" + this.userService.loggedinUser.tenantId + "/contracts/" + contractID)
        .toPromise().then(res => {
          this.ContractTypeList = res as ContractType[];
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  getContractTypes() {
    return new Promise((resolve, reject) => {
      this.http.get(this.contracttypeBaseUrl + "/ContractType?tenantId=" + this.userService.loggedinUser.tenantId).toPromise()
        .then((res: ContractType[]) => {
          this.ContractTypeList = res as ContractType[];
          let filteredData = res.filter((type: ContractType) => type.status == 'Approved');
          resolve(filteredData);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  getTransactionTypes() {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/transactionTypes").toPromise()
        .then((res: []) => {
          this.TransactionTypes = res;
          resolve(res);
        });
    });
  }

  saveContract(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    data.createdBy = this.userService.loggedinUser.id.toString();
    data.updatedBy = this.userService.loggedinUser.id.toString();
    data.completedStep = 1;
    data.version = 1;
    data.statusId = 1;
    data.aiEnabled = 1;
    return new Promise((resolve, reject) => {
      this.http.post(this.contractBaseUrl + "/tenants/" + this.userService.loggedinUser.tenantId + "/contracts", data, httpOptions).toPromise().then((res) => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  updateContract(data, cId) {
    return new Promise((resolve, reject) => {
      this.http.put(this.contractBaseUrl + "/tenants/" + this.userService.loggedinUser.tenantId + "/contracts/" + parseInt(cId), data).toPromise().then((res) => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  updateContractStatus(id, statusId, userId, actionName) {

    return new Promise((resolve, reject) => {
      let url = `${this.contracttypeBaseUrl}/Template/ContractStatusUpdate?contractId=${id}&statusId=${statusId}&userName=${this.userFullName}&CompletedStep=4&tenantId=${this.userService.loggedinUser.tenantId}&actionName=${actionName}`;

      // Check if actionName is something specific
      if (actionName === 'Review Submission') {
        // If actionName is something specific, include reviewerId
        url += `&reviewerId=${userId}`;
      } else if (actionName === 'Approval Submission') {
        // Otherwise, include approverId
        url += `&approverId=${userId}`;
      }

      this.http.post(url, {}).toPromise()
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });


      // this.http.post(this.contracttypeBaseUrl + "/Template/ContractStatusUpdate?contractId=" + id + "&statusId=" + statusId + "&userName=" + this.userFullName + "&CompletedStep=4&tenantId=" + this.userService.loggedinUser.tenantId + "&actionName=" + actionName + "&reviewerId=" + userId, {}).toPromise().then((res) => {
      //   resolve(res);
      // }).catch((error) => {
      //   reject(error)
      // });
    });
  }



  createContractAttributeValues(data, id: number) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return new Promise((resolve, reject) => {
      this.http.post(this.contractBaseUrl + "/tenants/" + this.userService.loggedinUser.tenantId + "/contracts/" + id + "/contractattributes", data, httpOptions).toPromise().then((res) => {
        resolve(res);
      }).catch((error) => {
        reject(error)
      });
    });
  }

  getContractTypeValues(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/tenants/" + this.userService.loggedinUser.tenantId + "/contracts/" + id + "/contractattributes").toPromise()
        .then((res: AttributeValues[]) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }
  updateContractTypeValues(data: AttributeValues[], id) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const promises = [];
    data.forEach((value: AttributeValues) => {
      if (value.id) {
        promises.push(this.http.put(this.contractBaseUrl + "/tenants/" + this.userService.loggedinUser.tenantId + "/contracts/" + id + "/contractattributes/" + value.id, value, httpOptions).toPromise())
      } else {
        let attr = [{ ...value }];
        this.http.post(this.contractBaseUrl + "/tenants/" + this.userService.loggedinUser.tenantId + "/contracts/" + id + "/contractattributes", attr, httpOptions).toPromise();
      }
    })

    return Promise.all(promises);

  }

  toggleReviewer(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contracttypeBaseUrl + "/Validation/ToggleContractReviewerStatus?contractReviewerId=" + id).toPromise()
        .then(res => {
          resolve(res);
        }).catch((error) => {
          reject(error)
        });
    });
  }
  toggleApprover(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contracttypeBaseUrl + "/Validation/ToggleContractApproverStatus?contractApproverId=" + id).toPromise()
        .then(res => {
          resolve(res);
        }).catch((error) => {
          reject(error)
        });
    });
  }

  getFullContractType(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contracttypeBaseUrl + "/contractType/" + id + "?tenantId=" + this.userService.loggedinUser.tenantId).toPromise()
        .then(res => {
          resolve(res);
        }).catch((error) => {
          reject(error)
        });
    });
  }
  getTemplates(ctId: number) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contracttypeBaseUrl + "/Template/" + ctId + "?tenantId=" + this.userService.loggedinUser.tenantId).toPromise()
        .then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
    });
  }

  getTemplates2(contractTypeIDFilter) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contracttypeBaseUrl + "/Template/" + contractTypeIDFilter + "?tenantId=" + this.userService.loggedinUser.tenantId).toPromise()
        .then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
    });
  }

  getAllTemplates() {
    return new Promise((resolve, reject) => {
      this.http.get(this.contracttypeBaseUrl + `/Template/GetAllTemplates?tenantId=${this.userService.loggedinUser.tenantId}`).toPromise()
        .then(res => {
          resolve(res);
        }).catch(error => {
          reject(error);
        });
    });
  }
  getContractTypeAttribute() {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + `/getContractsWithAttributesForReports/${this.userService.loggedinUser.tenantId}`

      ).toPromise().then((res) => {
        console.log('attribute', res)
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }
  getAllContracts() {
    return new Promise((resolve, reject) => {
      /*this.http.get("https://localhost:5001/contractType").toPromise()*/
      this.http.get(this.contractBaseUrl + "/tenants/" + this.userService.loggedinUser.tenantId + "/dashboard/contracts").toPromise()
        .then(res => {
          this.ContractList = res as Contract[];
          //console.log(this.ContractList);
          resolve(this.ContractList);
        });
    });
  }
  getClause(clauseId: number, contracttypeid: number = null, templateid: number = null) {

    return new Promise((resolve, reject) => {
      var query = "page=0&pageSize=1000&coloumnname=Name&orderbyflag=false";
      if (contracttypeid != null) {
        query += "&contracttype=" + contracttypeid;
      }
      if (templateid != null) {
        query += "&templateid=" + templateid;
      }
      this.http.get(this.contracttypeBaseUrl + "/Clauses/GetClauseById?" + query + "&tenantId=" + this.userService.loggedinUser.tenantId + "&clauseId=" + clauseId).toPromise()
        .then(res => {
          resolve(res);
        })
    });
  }

  getAllClauses(contracttypeid: number = null, templateid: number = null) {
    return new Promise((resolve, reject) => {
      var query = "page=0&pageSize=1000&coloumnname=Name&orderbyflag=false";
      if (contracttypeid != null) {
        query += "&contracttype=" + contracttypeid;
      }
      if (templateid != null) {
        query += "&templateid=" + templateid;
      }
      this.http.get(this.contracttypeBaseUrl + "/Clauses?" + query + "&tenantId=" + this.userService.loggedinUser.tenantId).toPromise()
        .then(res => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });;
    })
  }

  getContractClauseList(contractId: number) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contracttypeBaseUrl + "/Clauses/ContractClauseList?contractId=" + contractId + "&tenantId=" + this.userService.loggedinUser.tenantId).toPromise()
        .then(res => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  getContractSummaryAttribute(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/tenants/" + this.userService.loggedinUser.tenantId + "/contracts/" + id + "/contractsummaryattributes").toPromise()
        .then(res => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  getContractSummaryAttributeForAContract(contractid: number) {
    return this.http.get(this.contractBaseUrl + "/tenants/" + this.userService.loggedinUser.tenantId + "/contracts/" + contractid + "/contractsummaryattributes").toPromise();
  }


  getContractDetailsAttribute(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/tenants/" + this.userService.loggedinUser.tenantId + "/contracts/" + id + "/contractdetailattributes").toPromise()
        .then(res => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  getContractDetails(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/tenants/" + this.userService.loggedinUser.tenantId + "/contracts/" + id + "/contractdetailattributes").toPromise()
        .then(res => {
          resolve(res);
        }).catch((error) => {
          reject(error)
        });
    });
  }

  getAllAvailableApprovers(id, createdBy) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contracttypeBaseUrl + "/Validation/GetApproversbyContract/?ContractId=" + id + "&userid=" + createdBy + "&tenantId=" + this.userService.loggedinUser.tenantId).toPromise().then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }
  //////////Reviewer By Swapnil/////
  getAllAvailableReviewers(id, createdBy) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contracttypeBaseUrl + "/Validation/GetReviewerbyContract/?ContractId=" + id + "&userid=" + createdBy + "&tenantId=" + this.userService.loggedinUser.tenantId).toPromise().then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }
  /////////////////////////


  addApproverToContract(approver: Approver) {
    return new Promise((resolve, reject) => {
      approver.tenantId = this.userService.loggedinUser.tenantId;
      approver.userInfo.tenantId = this.userService.loggedinUser.tenantId;
      this.http.post(this.contracttypeBaseUrl + "/validation/saveapprovers", approver).toPromise()
        .then(res => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  addReviewerToContract(reviewer: Reviewer) {
    return new Promise((resolve, reject) => {
      reviewer.tenantId = this.userService.loggedinUser.tenantId;
      reviewer.userInfo.tenantId = this.userService.loggedinUser.tenantId;
      this.http.post(this.contracttypeBaseUrl + "/validation/saveReviewer", reviewer).toPromise()
        .then(res => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }


  getAllContractApprovers(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contracttypeBaseUrl + "/validation/getcontractapprovers?ContractId=" + id + "&tenantId=" + this.userService.loggedinUser.tenantId).toPromise()
        .then(res => {
          let allContractApprovers = res as Approver[];
          allContractApprovers.sort((a, b) => {
            if (a.sequenceNo > b.sequenceNo)
              return 1;
            if (b.sequenceNo > a.sequenceNo)
              return -1;
            else
              return 0;
          })
          resolve(allContractApprovers);
        }).catch((error) => {
          reject(error);
        });
    });
  }
  //////////swapnil///
  getAllContractReviewers(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contracttypeBaseUrl + "/Validation/GetContractReviwers?ContractId=" + id + "&tenantId=" + this.userService.loggedinUser.tenantId).toPromise()
        .then(res => {
          let allContractReviewers = res as Reviewer[];
          allContractReviewers.sort((a, b) => {
            if (a.sequenceNo > b.sequenceNo)
              return 1;
            if (b.sequenceNo > a.sequenceNo)
              return -1;
            else
              return 0;
          })
          resolve(allContractReviewers);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  getContractCreatedUser() {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/tenants/" + this.userService.loggedinUser.tenantId + "/users/" + this.Contract.createdBy).toPromise()
        .then(res => {
          this.thisContractCreatedBy = res as Users;
          //console.log(this.ContractList);

          resolve(true);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  generateDoc(id) {
    return new Promise((resolve, reject) => {
      return this.http.get(this.contracttypeBaseUrl + "/GenerateDocument/" + id + "/" + this.userFullName + "?tenantId=" + this.userService.loggedinUser.tenantId + "&userName=" + (this.userService.loggedinUser.firstName).toString() + ' ' + (this.userService.loggedinUser.lastName).toString()).toPromise().then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  downloadTemplate(templateId) {
    const downloadLink = document.createElement('a');
    downloadLink.href = this.contracttypeBaseUrl + "/GenerateDocument/DownloadTemplate?Templateid=" + templateId + "&tenantId=" + this.userService.loggedinUser.tenantId;
    downloadLink.setAttribute('download', '');
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  downloadDocument(cId = 0): Observable<any> {
    return this.http.get(this.contracttypeBaseUrl + "/GenerateDocument/contracturl/" + cId + "?tenantId=" + this.userService.loggedinUser.tenantId, { responseType: 'text' });

  }

  downloadPDF(cId) {
    const downloadLink = document.createElement('a');
    const currentUser = localStorage.getItem('currentUser');
    const user = JSON.parse(currentUser);
    downloadLink.href = this.contracttypeBaseUrl + "/GenerateDocument/contract/" + cId + "?tenantId=" + this.userService.loggedinUser.tenantId + "&userName=" + this.userService.loggedinUser.firstName + ' ' + this.userService.loggedinUser.lastName + '&jwt=' + user.jwt;
    downloadLink.setAttribute('download', '');
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  download(cId) {
    return this.contracttypeBaseUrl + "/GenerateDocument/contract/" + cId + "?tenantId=" + this.userService.loggedinUser.tenantId;
  }


  downloadSuportingDocument(id: number) {
    const downloadLink = document.createElement('a');
    downloadLink.href = this.contracttypeBaseUrl + "/GenerateDocument/SupportingDocument/" + id + "?tenantId=" + this.userService.loggedinUser.tenantId
    downloadLink.setAttribute('download', '');
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  uploadSupportingDocument(name: String, file: File, id) {
    const formData = new FormData();
    formData.append('files', file);
    var temp = '{"tenantId":' + this.userService.loggedinUser.tenantId + ',"name":"' + name + '","contractId":' + id + ',"documentPath":"' + name + '","createdBy":"' + this.userFullName + '","createdDate":"' + new Date().toISOString() + '","updatedBy":"' + this.userFullName + '","updatedDate":"' + new Date().toISOString() + '","isDeleted":false}';
    formData.append('supportingDocumentDto', temp);
    return new Promise((resolve, reject) => {
      this.http.post(this.contracttypeBaseUrl + '/GenerateDocument/SupportingDocuments', formData).toPromise().then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }
  uploadThirdPartyTemplate(file: File, id, IsThirdPartyContractUploaded: boolean = true) {
    const formData = new FormData();
    formData.append('files', file);

    return new Promise((resolve, reject) => {
      this.http.post(this.contracttypeBaseUrl + '/Template/ThirdParty?contractId=' + id + '&userName=' + this.userFullName + '&IsThirdPartyContractUploaded=' + IsThirdPartyContractUploaded + '&tenantId=' + this.userService.loggedinUser.tenantId, formData).toPromise().then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });

  }

  saveDocument(file: File, contractId: number, username: string, tenantId: number) {
    const formData = new FormData();
    formData.append('files', file);
    formData.append('tenantId', tenantId.toString());
    formData.append('IsThirdPartyContractUploaded', 'true'); // Default to true
    formData.append('userName', username);
    formData.append('contractId', contractId.toString());

    return new Promise((resolve, reject) => {
      this.http.post('http://35.189.94.89:8080/api/Template/ThirdParty', formData).toPromise()
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  uploadPDF(file: File, fields: any[], type: string) {
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onload = () => {
        const base64_str = reader.result.toString().split(',')[1]; // Extract base64 string
        const fieldsPayload: { [key: string]: any } = {};

        for (const field of fields) {
          const label = typeof field === 'string' ? field : field.label;
          const metaDataTypeId = typeof field === 'string' ? null : field.metaDataTypeId;
          const metaDataValues = typeof field === 'string' ? null : field.metaDataValues;

          // Map metaDataTypeId to appropriate field type
          if (metaDataTypeId === 9) {
            // Date type
            fieldsPayload[label] = "DD/MM/YYYY";
          } else if (metaDataTypeId === 3) {
            // Numeric type
            fieldsPayload[label] = "Integer";
          } else if (metaDataTypeId === 6) {
            // Decimal type
            fieldsPayload[label] = "Float";
          } else if (metaDataTypeId === 7) {
            // Currency type
            fieldsPayload[label] = "Currency";
          } else if (metaDataTypeId === 8) {
            // HyperLink type
            fieldsPayload[label] = "URL";
          } else if (metaDataTypeId === 12) {
            // Boolean type
            fieldsPayload[label] = "Boolean";
          } else if (metaDataTypeId === 2 || metaDataTypeId === 15) {
            // Dropdown or Multi Select type - send actual options
            if (metaDataValues) {
              // Parse comma-separated values into array
              fieldsPayload[label] = metaDataValues.split(/\s*,\s*/);
            } else {
              // Fallback to "Array" if no values are available
              fieldsPayload[label] = "Array";
            }
          } else if (metaDataTypeId === 4 || metaDataTypeId === 5) {
            // Text Area or Rich Text Area
            fieldsPayload[label] = "Text";
          } else {
            // Default for String (1), Label (10) and any unspecified types
            fieldsPayload[label] = "String";
          }
        }

        const payload = {
          base64_str,
          fields: fieldsPayload,
          type
        };

        // Log the payload to debug
        console.log('AI extraction payload:', payload);

        this.http.post('https://contract-ai-1007512864935.europe-west2.run.app/extract', payload).toPromise().then(res => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsDataURL(file); // Read the file as a data URL
    });
  }

  uploadSignedContract(file: File, id) {
    const formData = new FormData();
    formData.append('files', file);
    return this.http.post(this.contracttypeBaseUrl + '/Template/SignedDocumentUpload?contractId=' + id + '&userName=' + this.userFullName + '&statusId=3&tenantId=' + this.userService.loggedinUser.tenantId, formData).toPromise();
  }
  ///////////////
  updateStatusAfterSign(id) {
    return this.http.post(this.contracttypeBaseUrl + '/Template/ContractStatusUpdate?contractId=' + id + '&statusId=6' + '&userName=' + this.userFullName + '&completedStep=6&tenantId=' + this.userService.loggedinUser.tenantId, {}).toPromise();
  }
  ///////////////
  getAllDocuments(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contracttypeBaseUrl + "/GenerateDocument/SupportingDocumentDetails/" + id + "?tenantId=" + this.userService.loggedinUser.tenantId).toPromise().then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error)
      });
    });



  }
  sendForDocuSign(data) {
    return new Promise((resolve, reject) => {
      const requestBody = data.users.map((userId, index) => ({
        signingOrder: index + 1, // Start signing order from 1
        userId: userId
      }));
      this.http.post(this.contractBaseUrl + "/HelloSignApi/sendDocumentForSignatureToMultipleSigners?contractId=" + data.contractId, requestBody).toPromise().then((res) => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }
  //   sendForDocuSign(){
  //     console.log(this.DocuSignObject);
  //     //return this.http.post(this.contracttypeBaseUrl+"/DocuSignApi/SendDocumentForSignature?contractId="+this.DocuSignObject.contractID+"&emailId="+this.DocuSignObject.email+"&signatoryname="+this.DocuSignObject.name+"&tokenid="+this.DocuSignObject.secret+"&tenantId="+this.userService.loggedinUser.tenantId,{}).toPromise();
  //     return this.http.post(this.contractBaseUrl+"/HelloSignApi/SendDocumentForSignature?contractId="+this.DocuSignObject.contractID+"&emailId="+this.DocuSignObject.email+"&signatoryname="+this.DocuSignObject.name+"&tenantId="+this.userService.loggedinUser.tenantId,{}).toPromise();
  // }

  getContractEntitlement(id) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/tenants/" + this.userService.loggedinUser.tenantId + "/contracts/" + id + "/contractEntitlements").toPromise().then((res) => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });

  }

  getEntitlementType() {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/entitlementTypes").toPromise().then((res) => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    })
  }

  getEntitlementTimeLines() {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/entitlementTimeLines").toPromise().then((res) => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    })
  }

  getEntitlementReminderNotices() {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/entitlementReminderNotices").toPromise().then((res) => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    })
  }

  getEntitlementFrequencies() {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/entitlementFrequencies").toPromise().then((res) => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    })
  }


  getEntitlementApprovals() {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/entitlementApprovals").toPromise().then((res) => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    })
  }

  saveEntitlement(data, id) {
    data.tenantId = this.userService.loggedinUser.tenantId;
    data.createdBy = this.userFullName;
    data.updatedBy = this.userFullName;
    data.createDate = new Date().toISOString();
    data.updateDate = new Date().toISOString();
    data.deleted = false;

    const entitlement = [{ ...data }];
    return new Promise((resolve, reject) => {
      this.http.post(this.contractBaseUrl + '/tenants/' + this.userService.loggedinUser.tenantId + '/contracts/' + id + '/contractEntitlements', entitlement).toPromise().then((res) => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  editEntitlement(data, cId) {
    data.updatedBy = this.userFullName;
    data.updateDate = new Date().toISOString();
    data.contractEntitlementId = data.id;

    return new Promise((resolve, reject) => {
      this.http.put(this.contractBaseUrl + '/tenants/' + this.userService.loggedinUser.tenantId + '/contracts/' + cId + '/contractEntitlements/' + data.id, data).toPromise().then((res) => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  deleteEntitlement(entitlementId, contractId) {
    return new Promise((resolve, reject) => {
      this.http.delete(this.contractBaseUrl + '/tenants/' + this.userService.loggedinUser.tenantId + '/contracts/' + contractId + '/contractEntitlements/' + entitlementId).toPromise().then((res) => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  // The Validation endpoints below take free text (reason, userName) and
  // answer with a plain string, so build the query with HttpParams (which
  // encodes every value) and read the body as text instead of JSON.
  private get loggedinUserName(): string {
    const user = this.userService.loggedinUser;
    return [user?.firstName, user?.lastName].filter(Boolean).join(' ');
  }

  // Turns a failed request into something the user can act on, instead of the
  // generic "something went wrong" that hides which call actually broke.
  describeError(error: any): string {
    if (!error) return "";
    if (error.status === 0) return "Server not reachable.";
    const body = typeof error.error === "string" ? error.error.trim() : "";
    const detail = body && !body.startsWith("<") ? body : error.message || "";
    return [error.status ? `Error ${error.status}` : "", detail]
      .filter(Boolean)
      .join(": ");
  }

  private callValidation(action: string, params: HttpParams) {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.contracttypeBaseUrl + "/Validation/" + action, {
          params,
          responseType: 'text' as 'json'
        })
        .toPromise()
        .then((res) => {
          resolve(res);
        }).catch((error) => {
          reject(error);
        });
    });
  }

  approveContract(id) {
    return this.callValidation("Approve", new HttpParams()
      .set("ContractId", id)
      .set("ApproverId", this.userService.loggedinUser.id)
      .set("tenantId", this.userService.loggedinUser.tenantId)
      .set("userName", this.loggedinUserName));
  }
  //////////////////////////////////////////////////////////////////z
  reviewContract(id) {
    return this.callValidation("ChangeReviewerStatus", new HttpParams()
      .set("ContractId", id)
      .set("ReviewerId", this.userService.loggedinUser.id)
      .set("status", 1)
      .set("tenantId", this.userService.loggedinUser.tenantId));
  }

  declineContract(id, reason: String) {
    return this.callValidation("RejectReviewer", new HttpParams()
      .set("ContractId", id)
      .set("ReviewerId", this.userService.loggedinUser.id)
      .set("reason", reason.toString())
      .set("tenantId", this.userService.loggedinUser.tenantId)
      .set("userName", this.loggedinUserName));
  }

  rejectContract(id, reason: String) {
    return this.callValidation("Reject", new HttpParams()
      .set("ContractId", id)
      .set("ApproverId", this.userService.loggedinUser.id)
      .set("reason", reason.toString())
      .set("tenantId", this.userService.loggedinUser.tenantId));
  }

  getAuditLogs(id) {
    return new Promise((resolve, reject) => {
      this.http.get<any>(this.contracttypeBaseUrl + "/AuditLog?contractId=" + id + "&tenantId=" + this.userService.loggedinUser.tenantId).toPromise().then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getVersions(id) {
    return new Promise((resolve, reject) => {
      this.http.get<any>(this.contracttypeBaseUrl + "/DocumentVersion/Version?contractId=" + id + "&tenantId=" + this.userService.loggedinUser.tenantId).toPromise().then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  saveClauses(data) {
    const additionalProperties = {
      createdDate: new Date(),
      createdBy: this.userFullName,
      updatedDate: new Date(),
      updatedBy: this.userFullName,
      isDeleted: false,
      tenantId: this.userService.loggedinUser.tenantId
    };
    const requestData = { ...data, ...additionalProperties };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.post(this.contracttypeBaseUrl + "/Clauses/SaveContractTypeClauses", requestData, httpOptions).toPromise();
  }


  updateClause(data, clauseId) {
    const additionalProperties = {
      createdDate: new Date(),
      createdBy: this.userFullName,
      updatedDate: new Date(),
      updatedBy: this.userFullName,
      isDeleted: false,
      tenantId: this.userService.loggedinUser.tenantId,
      clauseId: clauseId
    };
    const requestData = { ...data, ...additionalProperties };
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.put(this.contracttypeBaseUrl + "/Clauses/UpdateContractTypeClauses", requestData, httpOptions).toPromise();
  }

  getClauseComparision(clauseId: number, id: number) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contracttypeBaseUrl + "/Clauses/ContractClause?contractId=" + id + "&clauseId=" + clauseId).toPromise().then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  deleteApprover(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(this.contracttypeBaseUrl + "/Validation/DeleteApprover?contractApproverId=" + id).toPromise().then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  deleteReviewer(id) {
    return new Promise((resolve, reject) => {
      this.http.delete(this.contracttypeBaseUrl + "/Validation/DeleteReviewer?contractReviewerId=" + id).toPromise().then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  sendForSignature(id, data) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      responseType: 'text' as 'json'
    };
    return new Promise((resolve, reject) => {
      this.http.post(this.contractBaseUrl + "/send_document_for_signature?contractId=" + id + "&tenantId=" + this.userService.loggedinUser.tenantId, JSON.stringify(data), httpOptions).toPromise().then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  getSigningDetails(contractId) {
    return new Promise((resolve, reject) => {
      this.http.get(this.contractBaseUrl + "/get_workflow_info?contractId=" + contractId + "&tenantId=" + this.userService.loggedinUser.tenantId).toPromise().then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  }
  // getContractTypeAttribute(){
  //   return new Promise ((resolve,reject)=>{
  //     this.http.get( this.contractBaseUrl + `/getContractsWithAttributesForReports/${this.userService.loggedinUser.tenantId}`

  //     ).toPromise().then((res)=>{
  //       console.log('attribute',res)
  //       resolve(res);
  //     }).catch((error)=>{
  //       reject(error);
  //     });
  //   });
  // }

  terminateContract(contractId: number, data: { terminationDate: Date, terminationReason: string }): Promise<any> {
    const params = {
      terminationDate: data.terminationDate.toISOString(),
      terminationReason: data.terminationReason
    };
    return this.http.put(`${this.contractBaseUrl}/terminateContract/${contractId}/${this.userService.loggedinUser.tenantId}/${this.userService.loggedinUser.id}`, null, { params }).toPromise();
  }

  // Fulfillment file upload
  uploadFulfillmentFile(file: File, contractId: number, contractEntitlementId: number): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);

    const url = `${this.contractBaseUrl}/tenants/${this.userService.loggedinUser.tenantId}/contracts/${contractId}/contractEntitlements/${contractEntitlementId}/upload`;

    return this.http.post(url, formData, {
      headers: {
        'Accept': 'application/json'
      }
    }).toPromise();
  }

  // Fulfillment file download
  downloadFulfillmentFile(contractId: number, contractEntitlementId: number): Promise<any> {
    const url = `${this.contractBaseUrl}/tenants/${this.userService.loggedinUser.tenantId}/contracts/${contractId}/contractEntitlements/${contractEntitlementId}/download`;

    return this.http.get(url, {
      headers: {
        'Accept': 'application/json'
      }
    }).toPromise();
  }

  // Get all notes for a contract
  getNotes(contractId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.contractBaseUrl}/tenants/${this.userService.loggedinUser.tenantId}/contracts/${contractId}/notes`)
        .toPromise()
        .then((res: any) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // Create a new note for a contract
  createNote(contractId: number, noteData: { note: string, comments?: string }): Promise<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const payload = {
      ...noteData,
      createdBy: this.userService.loggedinUser.id.toString()
    };
    return new Promise((resolve, reject) => {
      this.http.post(`${this.contractBaseUrl}/tenants/${this.userService.loggedinUser.tenantId}/contracts/${contractId}/notes`, payload, httpOptions)
        .toPromise()
        .then((res: any) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  // Update an existing note
  updateNote(contractId: number, noteId: number, noteData: { note: string, comments?: string }): Promise<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    const payload = {
      ...noteData,
      updatedBy: this.userService.loggedinUser.id.toString()
    };
    return new Promise((resolve, reject) => {
      this.http.put(`${this.contractBaseUrl}/tenants/${this.userService.loggedinUser.tenantId}/contracts/${contractId}/notes/${noteId}`, payload, httpOptions)
        .toPromise()
        .then((res: any) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  deleteNotes(contractId: number, noteId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.delete(`${this.contractBaseUrl}/tenants/${this.userService.loggedinUser.tenantId}/contracts/${contractId}/notes/${noteId}?deletedBy=${this.userService.loggedinUser.id.toString()}`)
        .toPromise()
        .then((res: any) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}




